import { IconButton, Modal } from '@mui/material';
import { Col, Row } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { getRandomImage } from "utils/config/reference";
import CloseIconss from "../../../utils/assets/images/closes.svg";
import WSCorrect from "../../../utils/assets/images/wsCorrect.svg";
import WSTime from "../../../utils/assets/images/wsTime.svg";
import { useWorkSheetSelector } from "store/worksheet/selectors";
import { useDispatch } from "react-redux";
import { setWorksheetView } from "store/worksheetView/action";
import SentryWrap from 'components/Sentry';

const ModalContent = styled.div`
  left: 50%;
  width: 50%;
  position: absolute;
  min-height: 440px;
  top: 50%;
  border-radius: 25px;
  transform: translate(-50%, -50%);
  background-color: ${(p) => p.bgColor || "#fff"};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  @media only screen and (max-width: 600px) {
    min-width: 90%;
  }
  @media only screen and (min-width: 601px) and (max-width: 768px) {
    width: 70%;
  }
`;

const TitleText = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: ${(p) => p.color || "black"};
`;
const RandomImage = styled.img`
  height: 290px;
  border-radius: 10px;
`;

const ScoreText = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: white;
  margin-bottom: 20px;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
`;

const ScoreRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  color: white;
  margin-bottom: 15px;
  position: relative;
  justify-content: center;
`;
const ContinueButton = styled.button`
  background-color: rgb(0, 15, 76);
  color: white;
  font-size: 16px;
  font-weight: bold;
  padding: 6px 14px;
  border-radius: 25px;
  border: none;
  cursor: pointer;
  text-align: center;
  outline: none;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: #34495e;
    transform: scale(1.05);
  }

  &:focus {
    outline: none;
  }
`;
const ScoreIcon = styled.div`
  font-size: 24px;
`;
const ButtonContainer = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 5px;
  justify-content: flex-end;
  padding: 0px 20px;
  @media only screen and (max-width: 600px) {
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding-bottom: 20px;
  }
  @media only screen and (min-width: 601px) and (max-width: 768px) {
    padding-bottom: 20px;
  }
`;
const ScoreIconText = styled.span`
  min-width: 160px;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
  font-size: 18px;
`;

export default function FinalResultScreen({
  page,
  isOpenFinalResult = false,
  setIsOpenFinalResult,
  timeSpent,
  handleTryAgain,
  totalQuestions,
  correctAnswers,
  handleNextWorksheet,
  setActiveIndex,
  is_assigned,
  is_student,
  is_submission,
  handleClose
}) {
  const dispatch = useDispatch();
  const [image, setImage] = useState("");
  const listWorkSheet = useWorkSheetSelector();

  const filterListWorksheet = useMemo(() => {
    const data = listWorkSheet?.filter((item) => item?.page_id === page);
    return data;
  }, [listWorkSheet, page]);


  useEffect(() => {
    setImage(getRandomImage());
  }, [isOpenFinalResult]);


  return (
    <SentryWrap>
      <Modal
        open={isOpenFinalResult}
        onClose={() => setIsOpenFinalResult(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <ModalContent bgColor={"rgb(39, 117, 148)"}>
          <Row
            style={{
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
              paddingBottom: 0,
            }}
          >
            <TitleText color="black"></TitleText>
            <div style={{ marginInline: "auto" }}>
              <ScoreText>Score Board:</ScoreText>
            </div>
            <IconButton
              onClick={() => {
                handleClose();
                setIsOpenFinalResult(false);
              }}
              style={{ padding: 0 }}
            >
              <img
                style={{ height: 20, marginTop: "-30px", marginLeft: "-10px" }}
                src={CloseIconss}
                alt=""
                title=""
              />
            </IconButton>
          </Row>
          <Row
            align="middle"
            style={{ padding: "20px", paddingTop: 0 }}
            gutter={[16, 16]}
          >
            <Col xs={24} md={12}>
              <ScoreRow>
                <ScoreIcon>
                  <img
                    style={{ marginRight: -9, height: 35 }}
                    src={WSCorrect}
                    alt="Student activity"
                    title="Student activity"
                  />
                </ScoreIcon>
                <ScoreIconText>{correctAnswers} Correct Answers</ScoreIconText>
              </ScoreRow>

              <ScoreRow style={{ position: "relative" }}>
                <ScoreIcon>
                  <img
                    style={{ marginRight: -9, height: 35 }}
                    src={CloseIconss}
                    alt="Student activity"
                    title="Student activity"
                  />
                </ScoreIcon>
                <ScoreIconText>
                  {totalQuestions - correctAnswers} Incorrect Answers
                </ScoreIconText>
              </ScoreRow>

              <ScoreRow>
                <ScoreIcon>
                  <img
                    style={{ marginRight: -9, height: 35 }}
                    src={WSTime}
                    alt="Student activity"
                    title="Student activity"
                  />
                </ScoreIcon>
                <ScoreIconText>{timeSpent}</ScoreIconText>
              </ScoreRow>
            </Col>

            {/* Right Side: Robot Image */}
            <Col
              xs={24}
              md={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <RandomImage src={image} alt="Random" />
            </Col>
          </Row>
          {/* Bottom Buttons */}
          {(is_assigned && is_student) ? (
            <ButtonContainer>
              <ContinueButton onClick={() => {
                setIsOpenFinalResult(false);
                dispatch(setWorksheetView({ open: false }));
              }}>
                {is_submission ? 'Close' : 'Submit'}
              </ContinueButton>
            </ButtonContainer>
          ) : (
            <ButtonContainer>
              <ContinueButton onClick={handleTryAgain}>
                Try again
              </ContinueButton>
              {filterListWorksheet?.length > 1 && (
                <ContinueButton
                  onClick={() => {
                    handleNextWorksheet();
                    setIsOpenFinalResult(false);
                    setActiveIndex(0);
                  }}
                >
                  Next Lesson
                </ContinueButton>
              )}
            </ButtonContainer>
          )}
        </ModalContent>
      </Modal>
    </SentryWrap>
  );
}
